import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { hot } from 'react-hot-loader';
import styled from 'styled-components';
import ErrorPage from '@zocdoc/components/src/ErrorPage';
import * as Layout from '@zocdoc/components/src/Layout';

import withLocation from '../config/location/withLocation';
import { isProduction } from '../utils/environment';
import parseError from './parseError';

export class ErrorView extends PureComponent {
    static propTypes = {
        errorCode: PropTypes.number,
        errorMessage: PropTypes.string,
        location: PropTypes.shape({
            hostname: PropTypes.string,
        }),
    };

    static defaultProps = {
        errorCode: typeof window !== 'undefined' ? window.__ERROR_CODE__ : 500,
        errorMessage: typeof window !== 'undefined' ? window.__ERROR__ : '',
        location: {},
    };

    render() {
        return (
            <Layout.Page>
                <Layout.Header />

                <Layout.PaddedContainer>
                    <ErrorPage statusCode={this.props.errorCode} />
                    {this.maybeRenderError()}
                </Layout.PaddedContainer>

                <Layout.Footer />
            </Layout.Page>
        );
    }

    maybeRenderError() {
        if (!isProduction(this.props.location.hostname)) {
            return (
                <ErrorMessage>{parseError(this.props.errorMessage)}</ErrorMessage>
            );
        }
    }
}

const ErrorMessage = styled.pre`
    margin-bottom: 10vh;
    white-space: pre-wrap;
`;

export default flowRight([
    hot(module),
    withLocation,
])(ErrorView);
